import { createSelector } from '@reduxjs/toolkit'
import { getBusinessTravellerSelectedTravellerState } from 'businessTraveller/storage/businessTravellerStorage'

export const selectSelectedTravellerGuestCount = createSelector(
  (state: App.State) => state.businessTraveller.selectedTravellerGuestCount,
  (state: App.State) => state.businessTraveller.selectedTravellerEmployeeIds,
  (selectedTravellerGuestCount, selectedTravellerEmployeeIds): number => {
    if (selectedTravellerGuestCount > 0 || selectedTravellerEmployeeIds.length > 0) {
      return selectedTravellerGuestCount
    }
    return getBusinessTravellerSelectedTravellerState()?.guestCount ?? 0
  },
)
